import React from 'react';
import {Box} from "grommet";
import styled from 'styled-components';

// Little gradient animation of the content line
const BoxWithLoadingStyling = styled(Box)`
    display: inline-block;
    ${props => props.isLoading && `
        color: transparent;
        background: linear-gradient(100deg, #eceff1 30%, #f6f7f8 50%, #eceff1 70%);
        background-size: 400%;
        animation: loading 0.6s ease-in-out infinite;
        
        @keyframes loading {
            0% {
            background-position: 100% 50%;
            }
            100% {
            background-position: 0 50%;
            }
        }
    `}
`;

const ContentLine = ({isLoading=false, ...rest}) => (
    <BoxWithLoadingStyling 
        responsive={false} 
        background={isLoading ? {} : { color: 'border' }} 
        margin={{ vertical: '0.35em' }} 
        round 
        height="0.5em" 
        width="100%"
        isLoading={isLoading ? isLoading : undefined}
        {...rest} />
);

export default ContentLine;